import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Banner() {
  return (
    <section className="banner_parcheesi banner_truth text_white">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo">
              <h1>TruthGPT</h1>
            </div>
            <p>
              TekRevol undertook the development of TruthGPT, an AI-powered
              mobile app designed to provide users with unbiased, transparent,
              and easily accessible information through a chatbot interface. 
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/truthgpt-ai-chatbot/id6446929134.">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.app.truthgpt&hl=en&gl=US">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/banner_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={594}
                height={600}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
